import * as React from 'react';
import { Button as AntdButton, ConfigProvider } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/lib/button';

import { AppContext } from '@/utils/appProvider';
import classnames from 'classnames';
import './index.less';

export interface ButtonProps extends AntdButtonProps {}

const Button: React.FC<ButtonProps> = props => {
  const { children, className } = props;
  const { prefixCls } = React.useContext(AppContext);

  return (
    <ConfigProvider autoInsertSpaceInButton={false}>
      <AntdButton {...props} className={classnames(`${prefixCls}-button`, className)}>
        {children}
      </AntdButton>
    </ConfigProvider>
  );
};

export default Button;
